import http from "../plugins/axios";
const BASE_URI = "/salon";
export default {
    getSalonPagination({
                          limit,
                          currentPage
                      }) {
        return http.get(`${BASE_URI}?limit=${limit}&currentPage=${currentPage}`);
    },
    uploadFile(formData) {
        return http.post(`${BASE_URI}/uploadFile`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
    create(data) {
        return http.post(`${BASE_URI}`, data);
    },
    update(data) {
        const { id } = data;
        return http.put(`${BASE_URI}/${id}`, data);
    },
    remove(id) {
        return http.delete(`${BASE_URI}/${id}`);
    }
};
